module.exports = "/assets/data/d917a112bce30fdf10df1093958245dd-HU4.data.json";